import { useEffect, useState } from "react";
import http from "@/lib/api";
import { Panel, Empty, fmt } from "./AdminKit";
import ReplyPanel from "./ReplyPanel";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Reply } from "lucide-react";

const MSG_STATUS = { new: "Новое", unread: "Новое", read: "Прочитано", answered: "Отвечено", closed: "Закрыто" };

function RequestRow({ r, onChange }) {
  const [open, setOpen] = useState(false);
  const mark = async (status) => {
    try { await http.put(`/v1/admin/contact-messages/${r.id}`, { status }); toast.success("Обновлено"); onChange(); } catch { toast.error("Ошибка"); }
  };
  const send = async (body) => { await http.post(`/v1/admin/contact-messages/${r.id}/send-reply`, body); toast.success("Ответ отправлен"); setOpen(false); onChange(); };
  return (
    <div className="rounded-lg border border-slate-700 bg-slate-700/30 p-4" data-testid={`contact-msg-${r.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <span className="font-semibold text-white">{r.name}</span>
          <span className="text-slate-400">{r.email}{r.phone ? ` · ${r.phone}` : ""}</span>
          <span className="inline-block px-2 py-0.5 rounded-full text-xs bg-slate-700 text-slate-200 border border-slate-600" data-testid={`contact-msg-status-${r.id}`}>{MSG_STATUS[r.status] || r.status}</span>
          {r.language && <span className="text-xs text-slate-400">{r.language.toUpperCase()}</span>}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-slate-500">{fmt(r.created_at)}</span>
          {r.status !== "read" && r.status !== "answered" && <Button size="sm" className="bg-slate-600 hover:bg-slate-500 text-white h-7" onClick={() => mark("read")} data-testid={`contact-msg-read-${r.id}`}>Прочитано</Button>}
          {r.status !== "closed" && <Button size="sm" className="bg-slate-700 hover:bg-slate-600 text-white h-7" onClick={() => mark("closed")} data-testid={`contact-msg-close-${r.id}`}>Закрыть</Button>}
          <Button size="sm" className="bg-blue-600 hover:bg-blue-700 text-white h-7 gap-1" onClick={() => setOpen(!open)} data-testid={`contact-msg-reply-btn-${r.id}`}><Reply className="h-3.5 w-3.5" />Ответить клиенту</Button>
        </div>
      </div>
      <p className="text-sm text-slate-200 whitespace-pre-wrap" data-testid={`contact-msg-text-${r.id}`}>{r.message}</p>
      {(r.replies || []).map((x, i) => (
        <div key={i} className="mt-2 text-xs rounded border border-emerald-800/60 bg-emerald-950/20 p-2" data-testid={`contact-msg-reply-${r.id}-${i}`}>
          <div className="text-slate-500">{fmt(x.at)} · e-mail: {x.email_status}</div>
          <div className="text-emerald-300">RU: <span className="text-slate-300">{x.text_ru}</span></div>
          <div className="text-blue-300 mt-1">Клиенту ({x.language?.toUpperCase()}): <span className="text-slate-300 whitespace-pre-wrap">{x.customer_text}</span></div>
        </div>
      ))}
      {open && <div className="mt-3 border-t border-slate-700 pt-3">
        <ReplyPanel id={r.id} draftKey={`contact-${r.id}`} composeUrl={`/v1/admin/contact-messages/${r.id}/compose-reply`} onSend={send} sendLabel={`Отправить на ${r.email}`} />
      </div>}
    </div>
  );
}

export default function AdminRequests() {
  const [rows, setRows] = useState([]);
  const load = () => http.get("/v1/admin/contact-messages").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-6" data-testid="admin-requests">
      <h1 className="text-2xl font-bold text-white">Запросы (контактные сообщения)</h1>
      <Panel title={`Всего: ${rows.length}`}>
        {rows.length === 0 ? <Empty /> : <div className="space-y-3">{rows.map((r) => <RequestRow key={r.id} r={r} onChange={load} />)}</div>}
      </Panel>
    </div>
  );
}
